import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// Store links (see mobile app.json bundle/package ids).
const IOS_STORE_URL =
    "https://apps.apple.com/am/app/ctrl-volunteering/id6791313545";
const ANDROID_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.ctrl.volunteerarmenia";

/**
 * Deep-link landing page for shared content (e.g. ctrl.am/post/:id).
 *
 * When the CTRL app is installed, the OS opens it directly via Universal Links
 * (iOS) / App Links (Android) and this page never renders. When it isn't
 * installed — or on desktop — we try the `ctrlapp://` custom scheme and then
 * fall back to the correct app store.
 *
 * `kind` is "post" | "event" and maps to the in-app route of the same name.
 */
export default function AppRedirect({ kind }) {
    const { id } = useParams();
    const [storeUrl, setStoreUrl] = useState(IOS_STORE_URL);

    useEffect(() => {
        const ua = navigator.userAgent || "";
        const isIOS = /iPhone|iPad|iPod/i.test(ua);
        const isAndroid = /Android/i.test(ua);
        const target = isAndroid ? ANDROID_STORE_URL : IOS_STORE_URL;
        setStoreUrl(target);

        if (!id) {
            window.location.replace(target);
            return;
        }

        const appUrl = `ctrlapp://${kind}/${id}`;
        const start = Date.now();

        // If the app opens, this tab is backgrounded and the timer is throttled;
        // the elapsed-time guard prevents bouncing to the store after returning.
        const timer = setTimeout(() => {
            if (Date.now() - start < 2000) window.location.replace(target);
        }, 1200);

        const onHide = () => {
            if (document.hidden) clearTimeout(timer);
        };
        document.addEventListener("visibilitychange", onHide);

        // Only mobile has the app; on desktop go straight to the store.
        if (isIOS || isAndroid) {
            window.location.href = appUrl;
        } else {
            clearTimeout(timer);
            window.location.replace(target);
        }

        return () => {
            clearTimeout(timer);
            document.removeEventListener("visibilitychange", onHide);
        };
    }, [id, kind]);

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontFamily: "Montserratarm, sans-serif",
                textAlign: "center",
                padding: 32,
            }}
        >
            <div>
                <div
                    style={{
                        fontSize: 22,
                        fontWeight: 800,
                        color: "#ff7b00",
                        letterSpacing: 1,
                    }}
                >
                    CTRL EVENTS
                </div>
                <p style={{ color: "#666", margin: "14px 0 22px" }}>
                    Opening in the app…
                </p>
                <a
                    href={storeUrl}
                    style={{
                        display: "inline-block",
                        background: "#ff7b00",
                        color: "#fff",
                        textDecoration: "none",
                        padding: "14px 26px",
                        borderRadius: 12,
                        fontWeight: 700,
                    }}
                >
                    Get the app
                </a>
            </div>
        </div>
    );
}
